(function() {
	'use strict';

	angular
		.module('pwc.controllers')
		.controller('UserController', UserController);

	UserController.$inject = ['$rootScope', '$window', 'userPouch', '$mdToast', '$log', 'lodash', '$q', 'Rollbar', '$analytics', 'Utils', 'API'];

	function UserController($rootScope, $window, userPouch, $mdToast, $log, lodash, $q, Rollbar, $analytics, Utils, API) {

		/* jshint validthis: true */
		var self = this;

		self.state = {
			success: false,
			message: ''
		};

		self.currentUser = {
			name: '',
			password: '',
			email: '',
			passwordConfirm: ''
		};

		// error message @TODO refactor login method & template to use self.state instead
		self.message = '';

		self.login = login;
		self.changePassword = changePassword;

		/** begin methods */

		function login(){

			$mdToast.show(
				$mdToast.simple()
					.content('Logging in...')
					.position("top right")
					.hideDelay(5000)
			);

			self.message = '';

			userPouch
				.login(self.currentUser.name, self.currentUser.password)
				.catch(function(error) {

					$rootScope.isActive = true;

					$log.debug('Error logging in', error);
					self.message = error.message;

					if (error.status === 401){
						self.message += ' Username and password are case-sensitive. Please try again.';
					}

					if (error.status === 500){
						self.message = 'Error logging in. Please check your internet connection and ensure it is active. Please also ensure you are NOT in private browsing / incognito mode. Refresh the page and try to log in again, when prompted "Allow this website to use space on your disk?" select the "allow" button. If the problem persists, please contact support@personalwinecurator.com.';
					}

					return $q.reject(error.message);
				})
				.then(function(response){

                    API.userIsActive(self.currentUser.name).catch(function(err){
                        // see if user has an active subscription, if not flag so we can show a warning
                        $rootScope.isActive = false;
                    });

					return userPouch.remote().getUser(self.currentUser.name)
						.catch(function(err){
							$log.debug('err getting user meta', err);
						});
				})
				.then(function(response){

					var user = angular.fromJson(response);

					$log.debug('Login complete', user);

					$log.debug('Redirecting to wines');

					$window._pq = $window._pq || [];

					$window._pq.push(['track', 'Customer']);

					$analytics.eventTrack('User Logged In');

					Utils.go('wines');

					$mdToast.show(
						$mdToast.simple()
							.content('Welcome back ' + lodash.get(user, 'metadata.billing.card.name', user.name) + '!')
							.position("top right")
							.hideDelay(5000)
					);
				});
		}

		function changePassword(){

			$log.debug("Changing user's password...");

			userPouch.changePassword(self.currentUser.password)
				.then(function(){

					self.state.success = true;

				}).catch(function(err){

					Rollbar.Rollbar.error(err);

					$log.error('Unable to change password.', err);

					self.state.message = 'Unable to change password. Please try again and contact support if issue persists';

				});
		}

	}

})();
